import React from "react";

export function Info() {
  return (
    <>
      <div className="bg-remark p-4 rounded border border-label overflow-hidden">
        <h3 className="lg:text-xl font-bold mb-4">產品</h3>
        <ol className="list-decimal list-inside">
          <li className="mb-4">SPT 三層過濾口罩（學生）</li>
          <li className="mb-4">型號：8156-1S</li>
          <li className="mb-4">原材料細菌過濾效率（BFE）>= 95%</li>
          <li className="mb-4">原材料微粒過濾效率（PFE）>= 95%</li>
          <li className="mb-4">ASTM F2100 Level 1測試進行中</li>
          <li className="mb-4">尺寸：約145mm x 95mm</li>
          <li className="mb-4">
            包裝：30 片/盒，每10片獨立包裝（往後月份可能更改為每片獨立包裝）
          </li>
          <li className="mb-4">預計出貨時間：2020年6月</li>
          <li className="mb-4">《香港製造Made in HK》</li>
        </ol>
        <h4 className="lg:text-lg font-bold mb-4">【付款方法】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">PayMe</li>
          <li className="mb-4">轉數快</li>
        </ol>
        <h4 className="lg:text-lg font-bold mb-4">【套裝計劃選擇】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">
            學生套裝 3 個月計劃
            <ol className="list-disc ml-6 mt-4 list-inside">
              <li className="mb-4">
                數量：每月2盒，為期3個月，共6盒，30 片/盒
              </li>
              <li className="mb-4">
                售價：港幣115元 x 2盒 x 3個月 = 港幣690元
              </li>
              <li className="mb-4">
                預計發貨日期：根據抽籤結果的取貨組別，於6月內發貨第一期（2盒）學生口罩給所有客戶
              </li>
            </ol>
          </li>
          <li className="mb-4">
            學生套裝 6 個月計劃
            <ol className="list-disc ml-6 mt-4 list-inside">
              <li className="mb-4">
                數量：每月2盒，為期6個月，共12盒，30 片/盒
              </li>
              <li className="mb-4">
                售價：港幣110元 x 2盒 x 6個月 = 港幣1,320元
              </li>
              <li className="mb-4">
                預計發貨日期：根據抽籤結果的取貨組別，於6月內發貨第一期（2盒）學生口罩給所有客戶
              </li>
            </ol>
          </li>
        </ol>
        <h4 className="lg:text-lg font-bold mb-4">【取貨方式】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">
            順豐速運：每月每單標準快遞（門到門）為港幤27元
          </li>
          <li className="mb-4">
            順豐速運：每月每單標準快遞（在各順豐站自取）為港幤27元
          </li>
          <li className="mb-4">
            香港郵政：每月每單本地派遞（在各郵局自取）為港幣11元
          </li>
          <li className="mb-4">
            免費自取點：SPT Mask
            口罩夢工場（沙田石門安麗街11號企業中心25樓19-30室）
          </li>
          <li className="mb-4">
            免費自取點：灣仔譚臣道76號-78號卓信商業大廈2樓02室
          </li>
        </ol>

        <h3 className="lg:text-xl font-bold mb-4">購買流程</h3>
        <h4 className="lg:text-lg font-bold mb-4">【登記階段】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">
            於2020年5月21日上午10時至下午3時之間進入登記網址。
          </li>
          <li className="mb-4">填寫電郵。</li>
          <li className="mb-4">
            選擇計劃：
            <ol className="ml-6 mt-4 list-inside">
              <li className="mb-4">
                <p className="inline-block">
                  1. 學生套裝3個月計劃 - 寄送服務（順豐速運/香港郵政）
                  <br />
                  *HK$690（2盒 x 3個月，共6盒）+ 順豐速運 HK$81 或<br />
                  *HK$690（2盒 x 3個月，共6盒）+ 香港郵政 HK$33
                </p>
              </li>
              <li className="mb-4">
                <p className="inline-block">
                  2. 學生套裝3個月計劃 - 取貨地點自取（石門/灣仔）
                  <br />
                  *HK$690（2盒 x 3個月，共6盒）+ 石門自取 HK$0 或<br />
                  *HK$690 （2盒 x 3個月，共6盒） + 灣仔自取 HK$0
                </p>
              </li>
              <li className="mb-4">
                <p className="inline-block">
                  3. 學生套裝6個月計劃 - 寄送服務（順豐速運/香港郵政）
                  <br />
                  *HK$1320（2盒 x 6個月，共12盒）+ 順豐速運 HK$162 或<br />
                  *HK$1320（2盒 x 6個月，共12盒）+ 香港郵政 HK$66
                </p>
              </li>
              <li className="mb-4">
                <p className="inline-block">
                  4. 學生套裝6個月計劃 - 取貨地點自取（石門/灣仔）
                  <br />
                  *HK$1320（2盒 x 6個月，共12盒）+ 石門自取 HK$0 或<br />
                  *HK$1320（2盒 x 6個月，共12盒）+ 灣仔自取 HK$0。
                </p>
              </li>
            </ol>
          </li>
          <li className="mb-4">
            採用抽籤方式，非先到先得，請慢慢填寫資料和選擇計劃和取貨方式。
          </li>
          <li className="mb-4">
            詳細取貨方式（如選擇寄送服務，有順豐速運或香港郵政的選項；如選擇取貨地點自取，有石門或灣仔的選項）會於購買時可以選擇。
            <ol className="ml-6 mt-4 list-inside">
              <li className="mb-4">
                <p className="inline-block">
                  順豐/郵政
                  <br />
                  * 順豐速運：+ HK$81（3個月）/ HK$162（6個月）
                  <br />* 香港郵政：+ HK$33（3個月）/ HK$66（6個月）
                </p>
              </li>
              <li className="mb-4">
                <p className="inline-block">
                  自取
                  <br />
                  * 沙田石門安麗街11號企業中心25樓19-30室：+ HK$0
                  <br />* 灣仔譚臣道76號-78號卓信商業大廈2樓02室：+ HK$0
                </p>
              </li>
            </ol>
          </li>
          <li className="mb-4">每個電郵只可登記一次。</li>
          <li className="mb-4">
            登記後不能更改電郵地址、套裝計劃和取貨方式。請小心填寫和選擇。
          </li>
          <li className="mb-4">登記人數不限。</li>
        </ol>
        <h4 className="lg:text-lg font-bold mb-4">【公佈抽籤結果】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">於2020年5月21日下午7時公佈。</li>
          <li className="mb-4">
            抽籤結果為：
            <ol className="ml-6 mt-4 list-inside">
              <li className="mb-4">（1）成功中籤</li>
              <li className="mb-4">（2）候補</li>
              <li className="mb-4">（3）未能中籤。</li>
            </ol>
          </li>
          <li className="mb-4">所有登記人士會收到電郵通知。</li>
        </ol>
        <h4 className="lg:text-lg font-bold mb-4">【購買階段一】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">於2020年5月21日下午7時開始。</li>
          <li className="mb-4">
            抽籤結果為成功中籤的顧客會收到附有購買連結的購買電郵。
          </li>
          <li className="mb-4">
            購買電郵內會列明您的取貨組別（取貨組別隨機編排，不會按登記時間），讓顧客根據預計發貨日期決定是否確認購買。
          </li>

          <li className="mb-4">購買時段一會於5月22日（星期五）下午3時結束。</li>

          <li className="mb-4">
            成功購買後，顧客會收到「你下了一個訂單」的確認電郵。
          </li>
        </ol>
        <h4 className="lg:text-lg font-bold mb-4">【購買階段二】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">於2020年5月22日下午7時開始。</li>
          <li className="mb-4">
            所有抽籤結果為候補的顧客大概會於5月22日下午7時收到通知是否成功抽中進入第二購買階段。
          </li>
          <li className="mb-4">
            被抽中的候補顧客會收到附有購買連結的購買電郵。
          </li>

          <li className="mb-4">
            被抽中的候補顧客取貨組別均為取貨組別4，顧客可根據預計發貨日期決定是否確認購買。
          </li>

          <li className="mb-4">購買時段二會於5月23日（星期六）下午3時結束。</li>

          <li className="mb-4">
            成功購買後，顧客會收到「你下了一個訂單」的確認電郵。
          </li>
        </ol>

        <h3 className="lg:text-xl font-bold mb-4">條款及細則</h3>
        <ol className="list-decimal list-inside">
          <li className="mb-4">一經付款，我們將無法為閣下修改或取消訂單；</li>
          <li className="mb-4">
            閣下所提供的資料只會用作購買相關商品之用，不會做任何其他用途，亦不會把資料傳送給主辦單位及服務供應商以外的任何第三方，資料亦會在商品派送完畢後三個月内銷毀；
          </li>
          <li className="mb-4">如有任何爭議，SPT Mask 將保留最終決定權。</li>
        </ol>

        <p>
          如有任何貨品查詢，歡迎瀏覽SPT Mask Facebook專頁{" "}
          <a
            className="hover:underline"
            href="https://www.facebook.com/sptmask"
          >
            https://www.facebook.com/sptmask
          </a>
          或電郵至我們的客戶服務 。
          <a
            className="hover:underline"
            href="mailto:sptmaskenquiry@sinopharmtech.com.hk"
          >
            sptmaskenquiry@sinopharmtech.com.hk
          </a>
        </p>
      </div>
    </>
  );
}
